import classNames from 'classnames';

interface Props<TOption extends string> {
  selectedOption: TOption;
  setSelectedOption: (selectedOption: TOption) => void;
  options: { [key in TOption]: string };
}

const SegmentedRadioControl = <TOption extends string>({
  selectedOption,
  setSelectedOption,
  options
}: Props<TOption>) => {
  return (
    <div className='flex rounded overflow-hidden bg-gray-800 px-1 py-1'>
      {Object.entries<string>(options).map(([option, optionText]) => (
        <button
          type='button'
          key={optionText}
          className={classNames('flex-1 px-2 hover:text-blue-200 rounded', selectedOption === option && 'bg-gray-700')}
          onClick={() => setSelectedOption(option as TOption)}
        >
          {optionText}
        </button>
      ))}
    </div>
  );
};

export default SegmentedRadioControl;
